import { H1, H2, P } from "design_lib";
export default function Capabilities() {
  return (
    <div>
      <P>
        A strategy is only as good as the organization’s ability to execute it. No matter how bold
        your strategic ambitions, they need to align with your company’s capabilities, resources,
        and culture. If you pursue a strategy that your organization cannot deliver—whether due to
        lack of expertise, insufficient resources, or cultural misalignment—you risk failure. The
        key to success lies in optimizing your strategy around what your organization does best.
        Focus on your unique strengths—whether in technology, talent, or processes—and use these as
        the foundation for your strategic goals. Where gaps exist, look for ways to either build the
        necessary capabilities internally or partner with others to fill them. This approach ensures
        your strategy is grounded in your company’s core strengths, making it both achievable and
        sustainable over time.
      </P>
      <P className="text-center">
        <i>
          “It is not enough to do your best; you must know what to do, and then do your best.” – W.
          Edwards Deming
        </i>
      </P>
      <H1>Examples:</H1>
      <H2>Patagonia: Aligning strategy with environmental sustainability and brand loyalty</H2>
      <P>
        Patagonia has built its strategy around its capabilities in environmental sustainability and
        brand loyalty. Its commitment to producing eco-friendly products aligns perfectly with its
        culture of environmental responsibility. The company’s resources—including its extensive
        supply chain, material sourcing expertise, and environmental advocacy—allow it to offer
        high-quality outdoor gear while maintaining its reputation as a sustainable brand. By
        staying true to its mission and continually refining its operational processes, Patagonia
        has effectively created a unique market niche. Their customers aren’t just loyal to the
        products; they’re aligned with the company’s broader environmental values, further
        strengthening the company’s strategic position.
      </P>
      <H2>Zara: Aligning strategy with fast fashion and supply chain efficiency</H2>
      <P>
        Zara, part of the Inditex group, has aligned its strategy with its capabilities in fast
        fashion and supply chain efficiency. The company’s ability to move from design to retail in
        a matter of weeks is a key capability that differentiates it in the fashion industry. Zara's
        strategic focus on rapid turnaround time and cost-effective production enables it to offer
        trendy, affordable apparel without holding large inventories. Its vertically integrated
        supply chain—where manufacturing and distribution are closely controlled—ensures speed and
        flexibility in responding to market demands, making it a leader in the fast-fashion space.
      </P>
      <H2>John Deere: Aligning strategy with agricultural innovation and customer relationships</H2>
      <P>
        John Deere has aligned its strategy with its capabilities in agricultural innovation and
        customer relationships. Known for its high-performance machinery and technology in farming,
        John Deere continuously leverages its expertise in engineering and technology to develop
        cutting-edge solutions that improve the efficiency of farmers worldwide. The company’s
        resources—including its advanced software solutions and integrated products—allow it to
        offer a comprehensive service package to customers. John Deere’s strategic focus on
        fostering long-term relationships with its customers ensures that it isn’t just selling
        machinery but is a valued partner in improving agricultural productivity.
      </P>
    </div>
  );
}
